import { useEffect } from 'react';
import { HaccpApiClient } from '@haccp/api-client';
import { useAuthStore } from '@/store/auth.store';

/**
 * Global singleton API client instance
 */
let apiClientInstance: HaccpApiClient | null = null;

/**
 * Initialize or get the global API client
 */
function getApiClient(): HaccpApiClient {
  if (!apiClientInstance) {
    apiClientInstance = new HaccpApiClient(
      import.meta.env.VITE_API_URL || 'http://localhost:3000'
    );
  }
  return apiClientInstance;
}

/**
 * Hook to get the global API client with auth sync
 * Automatically updates the client's token when auth state changes
 */
export function useApiClient(): HaccpApiClient {
  const token = useAuthStore((state) => state.token);
  const client = getApiClient();

  useEffect(() => {
    if (token) {
      client.setToken(token);
    } else {
      client.clearToken();
    }
  }, [token, client]);

  return client;
}

/**
 * Get the API client outside of React components (for initialization)
 */
export function getGlobalApiClient(): HaccpApiClient {
  return getApiClient();
}
